document.addEventListener("DOMContentLoaded", () => {
    const scrollers = document.querySelectorAll('.scroller');

    scrollers.forEach(scroller => {
        let isDown = false;
        let startX;
        let scrollLeft;
        let hasScrolled = false; // Flag to track if scrolling has occurred

        // Prevent default dragging for images and links with class 'title'
        const draggableElements = scroller.querySelectorAll('img, a.title');
        draggableElements.forEach(el => {
            el.addEventListener('mousedown', (e) => {
                // Preventing default behavior if the target is an image or a 'title' link
                if (e.target.tagName === 'IMG' || e.target.classList.contains('title')) {
                    e.preventDefault();
                }
            });
        });

        // Event listeners for the scroller
        scroller.addEventListener('mousedown', (e) => {
            isDown = true;
            scroller.classList.add('active');
            startX = e.pageX - scroller.offsetLeft;
            scrollLeft = scroller.scrollLeft;
            hasScrolled = false; // Reset the scroll flag on mouse down
        });

        scroller.addEventListener('mouseleave', () => {
            isDown = false;
            scroller.classList.remove('active');
        });

        scroller.addEventListener('mouseup', () => {
            isDown = false;
            scroller.classList.remove('active');
            if (!hasScrolled) {
                // Re-enable click events for links if no scrolling happened
                enableLinks(scroller);
            }
        });

        scroller.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - scroller.offsetLeft;
            const walk = (x - startX) * 2; //scroll-fast
            scroller.scrollLeft = scrollLeft - walk;

            if (Math.abs(walk) > 5) { // Threshold to consider as a scroll
                hasScrolled = true;
                disableLinks(scroller); // Disable click events for links during scroll
            }
        });

        function disableLinks(currentScroller) {
            currentScroller.querySelectorAll('a').forEach(link => {
                link.addEventListener('click', preventClick);
            });
        }

        function enableLinks(currentScroller) {
            currentScroller.querySelectorAll('a').forEach(link => {
                link.removeEventListener('click', preventClick);
            });
        }

        function preventClick(e) {
            if (hasScrolled) {
                e.preventDefault();
            }
        }
    });
});